'use client';

import React from 'react';
import type { ProductCardProps } from '@skin-seoul/shared-components';
import { VerticalProductCard, VerticalProductCardSkeleton } from '@skin-seoul/shared-components';
const FlashSaleProductCard = ({
  theme = 'light',
  onClick,
  ...props
}: ProductCardProps) => {
  return <VerticalProductCard onClick={onClick} {...props} theme={theme} data-sentry-element="VerticalProductCard" data-sentry-component="FlashSaleProductCard" data-sentry-source-file="FlashSaleProductCard.tsx">
      <VerticalProductCard.Image background="generic.0" bottomSlot={<VerticalProductCard.AddToCart mx={{
      base: 1,
      tablet: 2
    }} marginBottom={{
      base: 1,
      tablet: 2
    }} />} data-sentry-element="VerticalProductCard.Image" data-sentry-source-file="FlashSaleProductCard.tsx" />
      <VerticalProductCard.Content data-sentry-element="VerticalProductCard.Content" data-sentry-source-file="FlashSaleProductCard.tsx">
        <VerticalProductCard.InfoName data-sentry-element="VerticalProductCard.InfoName" data-sentry-source-file="FlashSaleProductCard.tsx" />
        <VerticalProductCard.InfoPrice data-sentry-element="VerticalProductCard.InfoPrice" data-sentry-source-file="FlashSaleProductCard.tsx" />
        <VerticalProductCard.InfoRating data-sentry-element="VerticalProductCard.InfoRating" data-sentry-source-file="FlashSaleProductCard.tsx" />
      </VerticalProductCard.Content>
    </VerticalProductCard>;
};
FlashSaleProductCard.Skeleton = VerticalProductCardSkeleton;
export default FlashSaleProductCard;